<template>
  <div class="newPage">
    <div class="con">
      <!-- 搜索框 -->
      <div class="search">
        <div class="box" style="flex: 1;">
          <div class="name">Channel</div>
          <div class="duoxuan">
            <el-checkbox v-model="checkList.a">Qmax，mV</el-checkbox>
            <el-checkbox v-model="checkList.b">Pulse Count</el-checkbox>
            <el-checkbox v-model="checkList.c">PDI,mW</el-checkbox>
            <el-checkbox v-model="checkList.d">Qmax.Pc</el-checkbox>
            <el-input v-model="checkList.e" size="mini" style="width: 60px;font-size: 15px;margin-top: 7px;"></el-input>
          </div>
        </div>
        <div class="box" style="margin-left: 10px;flex: 1;">
          <div class="name">Common</div>
          <div class="duoxuan" style="width:230px ;">
            <el-checkbox v-model="checkList2.a">Temp·C</el-checkbox>
            <el-checkbox v-model="checkList2.b">Humidity</el-checkbox>
            <el-checkbox v-model="checkList2.c">Load,%</el-checkbox>
            <el-checkbox v-model="checkList2.d">Watch Count</el-checkbox>
            <el-checkbox v-model="checkList2.e">Watch Series</el-checkbox>
            <el-checkbox v-model="checkList2.f">Moisture-Kg/M</el-checkbox>
          </div>
        </div>
        <div class="btns" style="margin: 10px;">
          <el-button type="primary" size="mini">Reset Zoom</el-button>
          <el-checkbox v-model="checkList2.g">Normalize</el-checkbox>
        </div>

        <div class="box" style="display: flex;align-items: center;">
          <el-date-picker v-model="value2" type="datetimerange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" align="right">
          </el-date-picker>
          <el-button type="primary" size="mini" style="margin-left: 10px;">Do Correlation Analysis</el-button>
        </div>
      </div>
      <div class="texted">Use (Alt or Ctrl or Shift+Mouse) combination to Zoom and R-Key to Reset-Zooml Use S
        and F keys to work with Cursors.</div>
      <vchart style="height: 32vh;" ref='vchart'></vchart>

      <div class="search">
        <div class="box">
          <div class="name">Channel</div>
          <div class="duoxuan" style="width: 500px;">
            <el-checkbox v-model="checkList3.a">CC_A</el-checkbox>
            <el-checkbox v-model="checkList3.b">CC_B</el-checkbox>
            <el-checkbox v-model="checkList3.c">CC_C</el-checkbox>
            <el-checkbox v-model="checkList3.d">RTD01</el-checkbox>
            <el-checkbox v-model="checkList3.e">RTD02</el-checkbox>
            <el-checkbox v-model="checkList3.f">RTD03</el-checkbox>
            <el-checkbox v-model="checkList3.g">RTD04</el-checkbox>
            <el-checkbox v-model="checkList3.h">RTD05</el-checkbox>
            <el-checkbox v-model="checkList3.i">RTD06</el-checkbox>
            <el-checkbox v-model="checkList3.j">RTD07</el-checkbox>
            <el-checkbox v-model="checkList3.k">RTD08</el-checkbox>
            <el-checkbox v-model="checkList3.l">RTD09</el-checkbox>
            <el-checkbox v-model="checkList3.m">RTD010</el-checkbox>
            <el-checkbox v-model="checkList3.n">RTD011</el-checkbox>
            <el-checkbox v-model="checkList3.o">RTD012</el-checkbox>
          </div>
        </div>
        <div class="box" style="margin-left: 10px;">
          <div class="name">Parameter</div>
          <div class="duoxuan">
            <el-radio v-model="checkList3.p" label="1">Max</el-radio>
            <el-radio v-model="checkList3.p" label="2">Average</el-radio>
          </div>
        </div>
        <div class="box" style="margin-left: 10px;">
          <div class="name">Averaging Period</div>
          <div class="duoxuan">
            <el-radio v-model="checkList3.q" label="1">Monthly</el-radio>
            <el-radio v-model="checkList3.q" label="3">Daily</el-radio>
            <el-radio v-model="checkList3.q" label="2">None</el-radio>
          </div>
        </div>
        <!-- <div class="box" style="margin-left: 10px;">
          <div class="name">type</div>
          <div class="duoxuan">
            <el-radio v-model="checkList3.r" label="1">Line</el-radio>
            <el-radio v-model="checkList3.r" label="2">Bar</el-radio>
          </div>
        </div> -->
        <el-checkbox style="margin-left: 10px;" v-model="checkList3.s">Show Values</el-checkbox>
      </div>
      <vchart style="height: 32vh;" ref='vchart2'></vchart>
    </div>
  </div>
</template>

<script>
  import vchart from '@/components/module/Charts/chart.vue';//echart图
  export default {
    components: {
      vchart
    },
    data () {
      return {
        options: {
          "toolbox": {
            "show": true,
            "showTitle": true,
            "top": "5",
            "right": "10",
            "feature": {
              "magicType": {
                "type": [
                  "line",
                  "bar",
                  "stack",
                  "tiled"
                ],
                "title": {
                  "line": "切换为折线图",
                  "bar": "切换为柱状图",
                  "stack": "切换为堆叠",
                  "tiled": "切换为平铺"
                }
              },
              "saveAsImage": {
                "show": true,
                "title": "下载图片"
              }
            }
          },
          "tooltip": {
            "trigger": "axis",
            "confine": true,
            "axisPointer": {
              "animation": false
            }
          },
          "xAxis": {
            type: 'category',
            boundaryGap: false,
            data: [
              "Mar 30",
              "Apr 1",
              "Apr 2",
              "Apr 3",
              "Apr 4",
              "Apr 5",
              "Apr 6",
              "Apr 7",
              "Apr 8",
              "Apr 9",
              "Apr 10",
              "Apr 11",
              "Apr 12",
              "Apr 13",
              "Apr 14",
              "Apr 15",
              "Apr 16",
              "Apr 17"
            ]
          },
          "yAxis": {

          },

          "grid": {
            "left": "2%",
            "right": "2%",
            top: 50,
            "bottom": "35",
            "containLabel": true
          },
          "legend": {
            "type": "scroll",
            "bottom": "5px",
            "tooltip": {
              "show": true
            },

          },
          "series": [{
            "name": "Temp",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Humidity,%",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Load,%",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Mositure in Air",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Aim Series",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "CC_A-Qmax,mV",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "CC_A-PPC",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "CC_A-PDI,rnW",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Aim Count",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },]
        },
        options2: {
          "title": {
            "text": "ChannelDistributionfor-4/14/200613:00",
            top: 10,
            "left": "center",
            "textStyle": {
              "fontSize": 13,
              "fontWeight": "normal",
              "color": "#22a7f2"
            }
          },
          "toolbox": {
            "show": true,
            "showTitle": true,
            "top": "5",
            "right": "50",
            "feature": {
              "magicType": {
                "type": [
                  "line",
                  "bar",
                  "stack",
                  "tiled"
                ],
                "title": {
                  "line": "切换为折线图",
                  "bar": "切换为柱状图",
                  "stack": "切换为堆叠",
                  "tiled": "切换为平铺"
                }
              },
              "saveAsImage": {
                "show": true,
                "title": "下载图片"
              }
            }
          },
          "tooltip": {
            "trigger": "axis",
            "confine": true,
            "axisPointer": {
              "animation": false
            }
          },
          "xAxis": {
            type: 'category',
            axisLabel: {
              rotate: 60, // 旋转标签
              margin: 20 // 标签与轴线之间的距离
            },
            boundaryGap: false,
            data: [
              "CC_A",
              "CC_B",
              "CC_C",
              "RTD01",
              "RTD02",
              "RTD03",
              "RTD04",
              "RTD05",
              "RTD06",
              "RTD07",
              "RTD08",
              "RTD09",
              "RTD10",
              "RTD11",
              "RTD12"
            ]
          },
          "yAxis": {

          },

          "grid": {
            top: 39,
            "left": "2%",
            "right": "2%",
            "bottom": "20",
            "containLabel": true
          },
          "legend": {
            "type": "scroll",
            "bottom": "1px",
            "tooltip": {
              "show": true
            },

          },
          series: [
            {
              "name": "Qmax.mV",
              "type": "bar",
              barGap: 0,
              "smooth": false,
              "markPoint": {
                "data": []
              },
              "symbol": "emptyCircle",
              "sampling": "average",
              "data": ['-','-','-','-','-','-','9','1','1','-','-','-','-','-','-','-','-',]
            },{
              "name": "Puise Count .PPC",
              "type": "bar",
              barGap: 0,
              "smooth": false,
              "markPoint": {
                "data": []
              },
              "symbol": "emptyCircle",
              "sampling": "average",
              "data": ['-','-','-','-','-','-','9','1','1','-','-','-','-','-','-','-','-',]
            },{
              "name": "PD1.mW",
              "type": "bar",
              barGap: 0,
              "smooth": false,
              "markPoint": {
                "data": []
              },
              "symbol": "emptyCircle",
              "sampling": "average",
              "data": ['-','-','-','-','-','-','9','1','1','-','-','-','-','-','-','-','-',]
            },
          ]
        },

        value2: '',
        input1: 'PPC',
        checkList: {
          a: true,
          b: true,
          c: true,
          d: false,
          e: 'PPC'
        },
        checkList2: {
          a: true,
          b: true,
          c: true,
          d: true,
          e: true,
          f: true,
          g: true,
        },
        checkList3: {
          a: true,
          b: true,
          c: true,
          d: true,
          e: true,
          f: true,
          g: true,
        },
      }
    },
    mounted () {
      this.$refs.vchart.setData(this.options,true);
      this.$refs.vchart2.setData(this.options2,true);
    },
    computed: {

    },



    methods: {
      submit () {
        this.$message({showClose: true,message: '提交成功',type: 'success'});
      }

    }
  }
</script>

<style lang="scss" scoped>
  .newPage {
    padding: 10px;

    .el-radio {
      margin-top: 3px;
    }

    .texted {
      color: #22a5f1;
      transform: translate(10px, 21px);
    }

    .search {
      display: flex;
    }

    .duoxuan {
      display: flex;
      flex-wrap: wrap;
      width: 220px;
      flex-direction: column;
      height: 60px;
    }

    .box {
      border: 1px solid #d7d7d7;
      border-radius: 8px;
      position: relative;
      display: inline-block;
      padding: 5px;

      .name {
        position: absolute;
        top: -8px;
        background: #fff;
        left: 14px;
      }
    }

    .con {
      background: #fff;
      box-sizing: border-box;
      padding: 10px;
    }
  }
</style>